import { useEffect, type RefObject } from "react";

type ResizableChart = {
  resize: () => void;
};

const useChartResize = (
  containerRef: RefObject<HTMLElement | null>,
  chartRef: RefObject<ResizableChart | null | undefined>,
) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeChart = () => {
      chartRef.current?.resize();
    };

    resizeChart();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", resizeChart);
      return () => window.removeEventListener("resize", resizeChart);
    }

    const observer = new ResizeObserver(resizeChart);
    observer.observe(container);

    return () => observer.disconnect();
  }, [containerRef, chartRef]);
};

export default useChartResize;
